import { useMemo } from 'react';
import useGradesTableStore from '../store/useGradesTableStore';
import useStudents from '../hooks/queries/useStudents';
import { IStudent, IStudentRow } from '../types';

const useStudentRows = () => {
  const classroom = useGradesTableStore(state => state.classroom);
  const { data: students } = useStudents(classroom?.id);

  return useMemo<IStudentRow[]>(() => (
    students.map<IStudentRow>((student: IStudent) => ({
      student,
    }))
  ), [students]);
};

export default useStudentRows;
